import TreeItem, { treeItemClasses, TreeItemProps } from '@mui/lab/TreeItem';
import { Box, SvgIconProps, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import '../../eTMF/modelViewer/ModelViewer.scss';
import { BoxComponent } from '../BoxComponent';
import { TypographyComponent } from '../TypographyComponent';
import FolderIcon from '@mui/icons-material/Folder';
export type TreeItemClick = (nodeId: string) => void;

export type StyledTreeItemProps = TreeItemProps & {
  labelIcon: React.ElementType<SvgIconProps>;
  labelInfo?: string;
  labelText: string;
  tooltipTitle: string;
  click?: (nodeId: string) => void;
};

export interface ITreeItem extends TreeItemProps {
  child?: ITreeItem[];
  text: string;
  tooltip?: string;
  treeitemclick?: (nodeId: string) => void;
  labelIcon?: React.ElementType<SvgIconProps>;
}

export const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.text.secondary,
  [`& .${treeItemClasses.content}`]: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '&.Mui-expanded': {
      fontWeight: theme.typography.fontWeightRegular
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
      color: 'var(--tree-view-color)'
    },
    [`& .${treeItemClasses.label}`]: {
      fontWeight: 'inherit',
      color: 'inherit'
    }
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 0,
    [`& .${treeItemClasses.content}`]: {
      paddingLeft: theme.spacing(2)
    }
  }
}));

export const StyledTreeItem = (props: ITreeItem) => {
  const { labelIcon = FolderIcon,  text, tooltip, ...other } = props;

  return (
    <StyledTreeItemRoot
      label={
        <Tooltip
          title={<TypographyComponent fontSize={12}>{tooltip ? tooltip : text}</TypographyComponent>}
          placement="top"
          followCursor={true}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}>
            <BoxComponent component={labelIcon} color="inherit" sx={{ mr: 1 }} />
            <TypographyComponent variant="body2" sx={{ fontWeight: 'inherit', flexGrow: 1 }}>
              {text}
            </TypographyComponent>
            {/* <TypographyComponent variant="caption" color="inherit">
              {labelInfo}
            </TypographyComponent> */}
          </Box>
        </Tooltip>
      }
      {...other}
    />
  );
};
